import axios from 'axios';
import {
  CUSTOMER_SERVICE_FEEDBACKS,
  FEEDBACK_MESSAGES,
  CUSTOMER_SERVICE_FEEDBACK_MESSAGES,
  CUSTOMER_SERVICE_SUBMIT_REPLY_BY_BUSINESS,
} from './constants';

/**
 * Get customer service feedbacks
 * @param fromDate string
 * @param toDate string
 * @param mode string [""]
 * @param type string [""]
 * @param includeCustomer bool [false]
 * @param includeMessages bool [false]
 * @param page int [0]
 * @param size int [50]
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getCustomerServiceFeedbacks(queryparams) {
  return axios
    .get(CUSTOMER_SERVICE_FEEDBACKS(), {
      params: queryparams,
    })
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

/**
 * Get customer feedback messages
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/customer_feedbacks_controller.rb#L43
 * @param ID feedback
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getFeedbackMessages(id, queryparams) {
  return axios
    .get(FEEDBACK_MESSAGES(id), { params: queryparams, withCredentials: true })
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

/**
 * Get customer feedback messages
 * @param feedbackId int
 * @param businessId int
 * @param includeCustomer bool [false]
 * @param includeMessages bool [false]
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getCustomerServiceFeedbackMessages(feedbackId, queryParams) {
  return axios
    .get(CUSTOMER_SERVICE_FEEDBACK_MESSAGES(feedbackId), {
      params: queryParams,
    })
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

export function customerServiceReplyByBusiness(feedbackId, data) {
  return axios
    .post(CUSTOMER_SERVICE_SUBMIT_REPLY_BY_BUSINESS(feedbackId), {
      body: data.comment,
    })
    .catch(error => {
      return Promise.reject(
        new Error(error.response.data.errors[0].user_message)
      );
    });
}
